import { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import InputText from "components/_refactor/text/input";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import LoadingData from "components/Loading/LoadingData";
import CardManual from "./componentes/card-manual";
import DialogPreviewManual from "./componentes/dialog-preview-manual";

export default function ManuaisFranquias() {
  const snackbar = useSnackbar();

  const [searching, setSearching] = useState(false);
  const [manuals, setManuals] = useState([]);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [selectedManual, setSelectedManual] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [filter, setFilter] = useState({
    search: "",
    category: null,
  });

  useEffect(() => {
    async function getCategories() {
      setCategoriesLoading(true);
      try {
        const response = await Api.get("categoria-list", "conteudo", "", true);
        setCategories(response.Result.Categorias || []);
      } catch (error) {
        snackbar.showMessage(error?.toString() || "Erro ao buscar categorias", {
          severity: "error",
        });
      } finally {
        setCategoriesLoading(false);
      }
    }
    getCategories();
  }, []);

  const handleSearch = async () => {
    setSearching(true);
    setHasSearched(true);

    try {
      let queryParams = "";

      if (filter.category?.IdDocumentoAreaCategoria) {
        queryParams += `?idCategoria=${filter.category.IdDocumentoAreaCategoria}`;
      }

      if (filter.search) {
        queryParams += queryParams
          ? `&nome=${filter.search}`
          : `?nome=${filter.search}`;
      }

      const response = await Api.get(
        "document-manual-list",
        "conteudo",
        queryParams,
        true
      );

      setManuals(response.Result?.Manuais || []);
      setTotalRegisters(response.Result?.TotalRegistro || 0);
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao buscar manuais", {
        severity: "error",
      });
      setManuals([]);
      setTotalRegisters(0);
    } finally {
      setSearching(false);
    }
  };

  const handleClearFilters = () => {
    setFilter({ search: "", category: null });
    setManuals([]);
    setTotalRegisters(0);
    setHasSearched(false);
  };

  const handleView = (manual) => {
    setSelectedManual(manual);
    setPreviewOpen(true);
  };

  const handleDownload = (manual) => {
    if (manual?.UrlArquivo) {
      window.open(manual.UrlArquivo, "_blank");
    }
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setSelectedManual(null);
  };

  const handleStopSearching = () => {
    setSearching(false);
  };

  return (
    <div>
      <HeaderClientes section="Manuais da Franquia" subsection="Operações" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={categoriesLoading || searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={12} sm={6}>
            <InputText
              label="Nome"
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              disabled={searching}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoCompleteField
              label="Categoria"
              onChange={(value) => setFilter({ ...filter, category: value })}
              value={filter.category}
              options={categories}
              optionLabelKey="Nome"
              optionIdKey="IdDocumentoAreaCategoria"
              loading={categoriesLoading}
              disabled={categoriesLoading || searching}
            />
          </Grid>
        </FilterCard>
        <LoadingData
          searching={searching}
          onClick={handleStopSearching}
          label="Buscando manuais..."
        />
        {!searching && hasSearched && (
          <Box style={{ marginTop: "1.5rem" }}>
            {manuals.length > 0 ? (
              <Grid container spacing={3}>
                {manuals.map((manual) => (
                  <Grid item xs={12} md={6} key={manual.IdDocumentoArea}>
                    <CardManual
                      manual={manual}
                      onView={handleView}
                      onDownload={handleDownload}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Card>
                <CardContent>
                  <Typography
                    variant="h5"
                    align="center"
                    style={{ color: "#666" }}
                  >
                    Nenhum manual encontrado
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{ color: "#999", marginTop: "0.5rem" }}
                  >
                    Verifique os filtros utilizados e tente novamente.
                  </Typography>
                </CardContent>
              </Card>
            )}
          </Box>
        )}
      </Container>

      <DialogPreviewManual
        open={previewOpen}
        onClose={handleClosePreview}
        manual={selectedManual}
      />
    </div>
  );
}
